module.exports = __webpack_public_path__ + "static/venice20897-24ebc2fd674252d07031ca86e5b2c974.png";